import React from "react";
import { isNil } from "lodash";
import Text, { TextVariant } from "@/components/ui/text";
import { formatNumber } from "@/utils/numbers";

interface Props {
  value: number | null | undefined;
  valueVariant: TextVariant;
}

const EMPTY_VALUE = "-";

const RenewalBookKPI: React.FC<Props> = ({ value, valueVariant }) => {
  if (isNil(value)) {
    return <Text variant={valueVariant}>{EMPTY_VALUE}</Text>;
  }

  // Mirrors the deal "% of owner's pipeline" formatting: two decimals, no currency.
  const formatted = formatNumber(value, 2, false, false, true).value;

  return (
    <Text variant={valueVariant} className="truncate">
      {formatted}%
    </Text>
  );
};

export default RenewalBookKPI;
